<script setup lang="ts">
import { onMounted, ref } from 'vue'
import { ModalCentered } from '../modal'
import { AuthPhone, AuthConfirm } from './'
import { useAccountStore } from '@caks/shared/store/store.account'

const store = useAccountStore()
const emit = defineEmits<{ (emit: 'close'): void }>()
const router = useRouter()

const authModal = ref(null)
const phone = ref('')
type ModalVisible = 'phone' | 'confirm' | 'info'

const visibleModal = ref<ModalVisible | null>('phone')

const toNextStep = () => {
  if (visibleModal.value === 'phone') {
    store.phone = phone.value.replace(/\D/g, '')
    visibleModal.value = 'confirm'
  } else if (visibleModal.value === 'confirm') {
    visibleModal.value = null
    authModal.value.hide()
  }
}

onMounted(() => authModal.value.show())
</script>

<template>
  <modal-centered ref="authModal" @hide="emit('close')">
    <auth-phone v-if="visibleModal === 'phone'" v-model:phone="phone" @to-next-step="toNextStep" />
    <auth-confirm v-else-if="visibleModal === 'confirm'" @to-next-step="toNextStep" />
  </modal-centered>
</template>

<style scoped lang="scss"></style>
